/**
 * Hides Adobe's "Standard feature" credit/cost indicator
 * (`<firefly-image-editor-generation-cost-indicator>`) inside the embedded
 * Firefly editor.
 *
 * The indicator is a Lit web component the prebuilt bundle renders in the
 * editor's (open) shadow DOM. The bundle exposes no config flag through our
 * interface boundary and no CSS `::part` to suppress it, so app-level CSS can't
 * reach it. The only in-repo lever is to inject a `display:none` rule into the
 * shadow root(s) that contain the indicator — see {@link injectShadowCss}.
 */

import {
	injectShadowCss,
	type ShadowStyleController,
} from './shadowStyleInjector';

const HIDE_SELECTOR = 'firefly-image-editor-generation-cost-indicator';
const HIDE_RULE = `${HIDE_SELECTOR}{display:none!important}`;

export type CostIndicatorHider = ShadowStyleController;

export function hideFireflyCostIndicator(
	container: HTMLElement,
): CostIndicatorHider {
	return injectShadowCss(container, {
		rule: HIDE_RULE,
		marker: 'data-ff-hide-cost',
	});
}
